export const calculateTotalAmount = (amount, installments, discount) => {
  console.log(amount, discount, installments);
  let totalAmount = amount;
  if (installments) totalAmount *= installments;
  const discountDecimal = discount / 100;
  const discountedAmount = totalAmount - totalAmount * discountDecimal;
  return discountedAmount;
};
